module.exports = __webpack_public_path__ + "img/336x280.d97c1f05.png";